import React from "react";
import { Container } from "react-bootstrap";
import PopularCoursesItem from "../CoursesItem/CoursesItem.";
import TitleSectionComponent from "../TitleSectionComponent/TitleSectionComponent";
import "./PopularCoursesComponent.css";
import { shuffle } from "lodash";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { BsShopWindow } from "react-icons/bs";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useEffect, useState } from "react";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
export default function PopularCoursesComponent() {
    const [courseList, setCourseList] = useState([]);
    const colors = [
        "#7443FF",
        "#69B721",
        "#5F0101",
        "#7345FB",
        "#83CD1A",
        "#34ebe1",
        "#c034eb",
        "#7443FF",
    ];
    const shuffledColors = shuffle(colors);
    useEffect(() => {
        axiosConfig
            .get("api/courses?page=1&price=-1&pageSize=8")
            .then((res) => {
                setCourseList(res.data.data);
            });
    }, []);
    return (
        <>
            <div className="background-popular-course">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0  0 1000 100"
                    preserveAspectRatio="none"
                    style={{}}
                >
                    <path
                        className="elementor-shape-fill"
                        d="M761.9,44.1L643.1,27.2L333.8,98L0,3.8V0l1000,0v3.9"
                    ></path>
                </svg>
            </div>
            <div className="popular-courses">
                <Container>
                    <TitleSectionComponent
                        title="آخرین دوره ها"
                        icon={<BsShopWindow />}
                        isShowMore={true}
                        url={"courses"}
                    />
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        pagination={{
                            clickable: true,
                        }}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            300: {
                                slidesPerView: 1.5,
                                spaceBetween: 20,
                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 40,
                            },
                            992: {
                                slidesPerView: 3,
                                spaceBetween: 40,
                            },
                            1400: {
                                slidesPerView: 4,
                                spaceBetween: 40,
                            },
                        }}
                        modules={[Pagination, Autoplay]}
                        className="mySwiper"
                    >
                        {courseList?.map((item, index) => (
                            <SwiperSlide key={item.id}>
                                <PopularCoursesItem
                                    item={item}
                                    backgroundColor={shuffledColors[index]}
                                />
                                <div className="progress-bar">
                                    <ProgressBar now={item.percentComplete} />
                                    <h3>
                                        {item.percentComplete} درصد دوره تکمیل
                                        شده
                                    </h3>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Container>
            </div>
        </>
    );
}
